export const EIN_LETTER_FILTERS = ['ready', 'needs_check', 'needs_business', 'missing'] as const;
export type EinLetterFilter = (typeof EIN_LETTER_FILTERS)[number];

export interface AgencyEinSearch {
  q?: string;
  status?: EinLetterFilter;
}

export const parseEinFilter = (raw: unknown): EinLetterFilter | undefined =>
  typeof raw === 'string' && (EIN_LETTER_FILTERS as readonly string[]).includes(raw) ? (raw as EinLetterFilter) : undefined;

export const parseEinQuery = (raw: unknown): string | undefined => {
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim().slice(0, 100);
  return trimmed || undefined;
};

/** Route `validateSearch`: unknown keys and values are dropped so the plain nav link stays clean. */
export function parseAgencyEinSearch(search: Record<string, unknown>): AgencyEinSearch {
  const q = parseEinQuery(search.q);
  const status = parseEinFilter(search.status);
  return { ...(q && { q }), ...(status && { status }) };
}
